
<ng-container *ngFor="let item of arItems$">
    <app-material-summary-item [item$]="item" [PCore$]="PCore$"
        [menuIconOverride$]="menuIconOverride$" [menuIconOverrideAction$]="menuIconOverrideAction$" ></app-material-summary-item>
</ng-container>


